import { Component, Inject, Input } from '@angular/core';
import { TicketDetailsComponent } from '../../ticket-details.component';
import { Suggestion } from '../../../core/models/suggestion.model';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGComponent } from '../../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { NgClass } from '@angular/common';
import { ReadMoreComponent } from './read-more/read-more.component';
import { ScoreBarComponent } from './score-bar/score-bar.component';

@Component({
    selector: 'app-suggestions',
    templateUrl: './suggestions.component.html',
    styleUrls: ['./suggestions.component.scss'],
    imports: [TranslateModule, InlineSVGComponent, NgClass, ReadMoreComponent, ScoreBarComponent],
})
export class SuggestionsComponent {
    @Input() suggestions: Suggestion[];

    constructor(@Inject(TicketDetailsComponent) public parent: TicketDetailsComponent) {}
}
